import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ourTeamData from "../../data/our-team.json";

export default function Teams() {
  return (
    <>
      <section className="team-member-section ptb-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 col-md-8">
              <div className="section-heading text-center mb-4">
                <h2>{ourTeamData.title}</h2>
                <p className="lead">{ourTeamData.description}</p>
              </div>
            </div>
          </div>
          <div className="row d-flex justify-content-center gap-16">
            {ourTeamData.members.map((member) => (
              <div key={member.id} className="col-lg-4 col-md-6 col-sm-6">
                <div className="single-team-member position-relative my-lg-3 my-md-3 my-sm-0">
                  <div className="team-image">
                    <img
                      src={require(`../../images/our-team/${member.image}`)}
                      alt="Team Members"
                      className="img-fluid rounded"
                    />
                  </div>
                  <div className="team-info text-white rounded d-flex flex-column align-items-center justify-content-center">
                    <h5 className="mb-0">{member.name}</h5>
                    <h6>{member.role}</h6>
                    <ul className="list-inline team-social social-icon my-4 text-white">
                    <li className="list-inline-item">
                        <a href={member.socials.linkedin} target="_blank">
                          <span className="ti-linkedin"></span>
                        </a>
                      </li>
                      {/* <li className="list-inline-item">
                        <Link to={member.socials.facebook}>
                          <span className="ti-facebook"></span>
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link to={member.socials.twitter}>
                          <span className="ti-twitter"></span>
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link to={member.socials.github}>
                          <span className="ti-github"></span>
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link to={member.socials.dribbble}>
                          <span className="ti-dribbble"></span>
                        </Link>
                      </li> */}
                    </ul>
                    <Link
                      className="btn app-store-btn"
                      to={`/our-team/${member.id}`}
                    >
                      View details
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
